// SignalRService.ts
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { API_MSHospitalBaseUrl, API_MOPCRMBASEURL } from "../../crm/common/common";


export default class SignalRService {
  private connection: HubConnection | null = null;

  async startConnection() {
    this.connection = new HubConnectionBuilder()
      .withUrl(API_MOPCRMBASEURL + "notifications") // Change this URL based on your SignalR hub configuration
      .withAutomaticReconnect()
      .build();

    await this.connection.start();
  }

  async stopConnection() {
    if (this.connection) {
      await this.connection.stop();
      this.connection = null;
    }
  }

  async SendTaskNotification(callback: (message: any) => void) {
    if (this.connection) {
      this.connection.on("SendTaskNotification", (message: any) => {
        callback(message);
      });
    }
  }
  async SendLiveCallsNotification(callback: (message: any) => void) {
    if (this.connection) {
      this.connection.on("SendLiveCallsNotification", (message: any) => {
        callback(message);
      });
    }
  }

  async SendAnsweredCallsNotification(callback: (message: any) => void) {
    if (this.connection) {
      this.connection.on("SendAnsweredCallsNotification", (message: any) => {
        callback(message);
      });
    }
  }

  async SendMissedCallsNotification(callback: (message: any) => void) {
    if (this.connection) {
      this.connection.on("SendMissedCallsNotification", (message: any) => {
        callback(message);
      });
    }
  }
  async SendWhatsappNotification(callback: (message: any) => void) {
    if (this.connection) {
      this.connection.on("SendWhatsappNotification", (message: any) => {
        callback(message);
      });
    }
  }
  async SendWhatsappMessage(callback: (message: any) => void) {
    if (this.connection) {
      this.connection.on("SendWhatsappMessage", (message: any) => {
        callback(message);
      });
    }
  }
}
